import script from "./address.vue?vue&type=script&setup=true&lang=js"
export * from "./address.vue?vue&type=script&setup=true&lang=js"

import "./address.vue?vue&type=style&index=0&id=466484e8&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466484e8"]])

export default __exports__